export default "__VITE_PUBLIC_ASSET__53ffa601__"